import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useStore } from '~/app/store'
import { RoleEdit } from '~/entities/roles/role-edit'
import { usePageTitle, useToast } from '~/shared/lib'
import {
  Button,
  DeleteSVG,
  IconSave,
  MaxWidthContainer,
  PageTitle,
} from '~/shared/ui'
import Spinner from '~/shared/ui/spinner'
import { ModalDeleteRole } from './modal-delete'
import { useErrorHandler } from '~/shared/lib/hooks/use-error-handler'

export const RoleEditFeature = observer(() => {
  const { t } = useTranslation(['common', 'roles'])
  const { usersStore } = useStore()
  const [openModal, setOpenModal] = useState(false)
  const { loaders, permissions, getPermission, updateRole, roleById } =
    usersStore
  const toast = useToast()
  const { handleErrorWithToast } = useErrorHandler()

  const navigate = useNavigate()

  useEffect(() => {
    if (!permissions) {
      getPermission()
    }
  }, [getPermission, permissions])

  usePageTitle({
    title: t('roles:editRole'),
  })

  return (
    <MaxWidthContainer>
      <div className="flex justify-between items-center pb-6">
        <PageTitle
          withBackButton
          title={t('roles:editRole')}
          size="text-[24px]"
          color="text-[#242424]"
        />
        <div className="flex gap-3">
          <Button
            intent="danger"
            onClick={() => {
              setOpenModal(true)
            }}
          >
            {loaders.roleDelete ? <Spinner /> : <DeleteSVG color="white" />}
            {t('delete')}
          </Button>
          <Button
            intent="success"
            onClick={async () => {
              try {
                await updateRole()
                navigate('/settings')
                toast.open(t('roles:roleUpdatedSuccess'), 'success')
              } catch (error) {
                handleErrorWithToast(error)
              }
            }}
          >
            {loaders.roleEdit ? <Spinner /> : <IconSave />}
            {t('save')}
          </Button>
        </div>
      </div>
      <RoleEdit />
      <ModalDeleteRole
        isOpen={openModal}
        id={roleById?.id}
        onClose={(e) => {
          e.preventDefault()
          setOpenModal(false)
        }}
      />
    </MaxWidthContainer>
  )
})
